export enum NotificationType {
    CAMPAIGN = 1,
    CHARITY = 2,
    ORPHAN = 3,
    INFO = 4,
}

export enum TopicType {
    GLOBAL = 'global',
    GUEST = 'guest',
    DONNER = 'donner'
}

export const getNotificationColor = (status: NotificationType) => {
    switch (status) {
        case NotificationType.CAMPAIGN:
            return "green";
        case NotificationType.CHARITY:
            return "red";
        case NotificationType.ORPHAN:
            return "blue";
        case NotificationType.INFO:
            return "blue";
        default:
            return "red";
    }
};

// Status Boolean stuts
export const getNotificationType = (status: NotificationType) => {
    switch (status) {
        case NotificationType.CAMPAIGN:
            return "campaign";
        case NotificationType.CHARITY:
            return "charity";
        case NotificationType.ORPHAN:
            return "orphan";
        case NotificationType.INFO:
            return "general";
        default:
            return "default";
    }
};
